"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const BuyContent_1 = __importDefault(require("../BuyContent"));
const SellContent_1 = __importDefault(require("../SellContent/SellContent"));
const styled_1 = require("./styled");
const store_1 = require("../../context/store");
const Debug_1 = __importDefault(require("../Debug"));
const useGeoLocation_1 = __importDefault(require("../../hooks/useGeoLocation"));
const actions_1 = require("../../context/actions");
const useGeoCurrency_1 = __importDefault(require("../../hooks/useGeoCurrency"));
const constants_1 = require("../../data/constants");
const Tabs = ({ selectedTab }) => {
    const [tab, setTab] = (0, react_1.useState)(selectedTab || "buy");
    const { debug, geoCurrency, geoLocation, initialCrypto, initialFiat, hideTabs, } = (0, store_1.useTrackedState)();
    const dispatch = (0, store_1.useDispatch)();
    (0, useGeoLocation_1.default)();
    (0, useGeoCurrency_1.default)(geoLocation === null || geoLocation === void 0 ? void 0 : geoLocation.alpha2);
    (0, react_1.useEffect)(() => {
        if (!geoCurrency || initialFiat)
            return;
        dispatch({
            type: actions_1.CONTEXT_ACTIONS.SET_SELECTED_FIAT,
            payload: geoCurrency.currency,
        });
    }, [geoCurrency, dispatch, initialFiat]);
    if (hideTabs) {
        return (react_1.default.createElement(styled_1.ContentWrapper, null,
            tab === "buy" && react_1.default.createElement(BuyContent_1.default, null),
            tab === "sell" && react_1.default.createElement(SellContent_1.default, null)));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styled_1.WidgetWrapper, null,
            react_1.default.createElement(styled_1.TabWrapper, { tab: tab },
                react_1.default.createElement(styled_1.Tab, { selected: tab === "buy", onClick: () => {
                        setTab("buy");
                        dispatch({
                            type: actions_1.CONTEXT_ACTIONS.SET_SELECTED_CRYPTO,
                            payload: initialCrypto || constants_1.DEFAULT_CRYPTO_BUY,
                        });
                    } },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "main.buy" })),
                react_1.default.createElement(styled_1.Tab, { selected: tab === "sell", onClick: () => {
                        setTab("sell");
                        dispatch({
                            type: actions_1.CONTEXT_ACTIONS.SET_SELECTED_CRYPTO,
                            payload: initialCrypto && !(initialCrypto === null || initialCrypto === void 0 ? void 0 : initialCrypto.buyOnly)
                                ? initialCrypto
                                : constants_1.DEFAULT_CRYPTO_SELL,
                        });
                    } },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "main.sell" }))),
            react_1.default.createElement(styled_1.ContentWrapper, null,
                tab === "buy" && react_1.default.createElement(BuyContent_1.default, null),
                tab === "sell" && react_1.default.createElement(SellContent_1.default, null))),
        debug && react_1.default.createElement(Debug_1.default, null)));
};
exports.default = Tabs;
//# sourceMappingURL=Tabs.js.map